// The department a radiology study belongs to.
//
// It is the service master's classification, carried on the order as
// classification_name (or legacy service_classification_name) and mapped to
// `department` by mapRadiologyApiOrder in radiologyOrdersShared.js.
//
// An order placed before the classification was recorded (or against a service
// that has none) has no department. Those are collected under one bucket rather
// than guessed at: a requisition sent to the wrong room is worse than one the
// department has to route by hand.

export const UNCLASSIFIED = "Unclassified";

/** Department for one board order (radiologyOrdersShared mapRadiologyApiOrder shape). */
export function resolveRadiologyDepartment(order) {
  const name = String(order?.department ?? "").trim();
  return name && name !== "-" ? name : UNCLASSIFIED;
}

/**
 * Departments present in a set of orders, each with its study count, ordered
 * the way the chips read best: named departments A–Z, Unclassified last.
 */
export function departmentCounts(orders) {
  const counts = new Map();
  (orders || []).forEach((o) => {
    const dept = resolveRadiologyDepartment(o);
    counts.set(dept, (counts.get(dept) || 0) + 1);
  });
  return Array.from(counts.entries())
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => {
      if (a.name === UNCLASSIFIED) return 1;
      if (b.name === UNCLASSIFIED) return -1;
      return a.name.localeCompare(b.name);
    });
}
